import { privateApi } from 'api'
import { AxiosResponse } from 'axios'
import {
  IPickupPointsRequest,
  IPickupPointsResponse
} from 'models/pickupPoint'

export const pickupPointsApi = {
  getPickupPoints(
    data: IPickupPointsRequest
  ): Promise<AxiosResponse<IPickupPointsResponse>> {
    return privateApi.post<IPickupPointsResponse>('pickup-points', data)
  }
}
